__turbopack_context__.v({
  "collapsedSidebar": "SideNavLayout-module-scss-module__dKax5W__collapsedSidebar",
  "contentWrapper": "SideNavLayout-module-scss-module__dKax5W__contentWrapper",
  "logoContainer": "SideNavLayout-module-scss-module__dKax5W__logoContainer",
  "main": "SideNavLayout-module-scss-module__dKax5W__main",
  "sideBarContainer": "SideNavLayout-module-scss-module__dKax5W__sideBarContainer",
  "sideBarContainerWrap": "SideNavLayout-module-scss-module__dKax5W__sideBarContainerWrap",
  "sideBarWrapper": "SideNavLayout-module-scss-module__dKax5W__sideBarWrapper",
});
